import React, { useRef, useEffect, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend,CategoryScale } from "chart.js/auto";
import { Bar ,Line} from "react-chartjs-2";
import * as d3 from 'd3';

const BarGraph = ({data,height,width}) => {
 
  const [userCount,setUserCount]=useState()
  const [regesteredMonths,setRegesteredMonths]=useState()
  const [reversedMonths,setReversedMonths]=useState()
  const [reversedData,setReveredData]=useState()
  const colors =["#95A4FC","#BAEDBD","#C5B0F6","#FC9778"]
  

  useEffect(() => {
    let userCountPerMonth= []
    let months = []
    data.map((d) => {
      userCountPerMonth.push(d.user_count)
      months.push(d.month)
     
    })
   
    setUserCount(userCountPerMonth)
    setRegesteredMonths(months)
   
 }, [data])


 useEffect(() => {
  if(regesteredMonths !== undefined){
 let reverseMonths = regesteredMonths.reverse()
   let reveredData = userCount.reverse()
     setReversedMonths(reverseMonths)
     setReveredData(reveredData)
   
  }
}, [regesteredMonths])

  const userdata = {
    labels: reversedMonths,
    datasets: [{
      label: 'users registered ',
      data: reversedData,
      backgroundColor: ["#0A2FB6"],
      borderColor: ["#0A2FB6"],
      borderWidth: 1
    }],

  
  };

  const options = {
    scales: {
        y: {
            border:{dash: [4, 4]}, // for the grid lines
            grid: {
                color: '#aaa', // for the grid lines
                tickColor: '#000', // for the tick mark
                tickBorderDash: [2, 3], // also for the tick, if long enough
                tickLength: 10, // just to see the dotted line
                tickWidth: 2,
                offset: true,
                drawTicks: true, // true is default 
                drawOnChartArea: true // true is default 
            },
            
            beginAtZero: true,
            ticks: {
              color: 'black' // Change the color of x-axis labels here
            }
        },
        x: {
            display: true,
            ticks: {
              color: 'black' // Change the color of x-axis labels here
            }
        }
    },
    plugins: {
      legend: {
        display: false, // Hide dataset labels
      },
    },
    maintainAspectRatio: false, // Make the chart responsive
  responsive: true, // Enable responsiveness
};


  return (

    <div  >
     <Bar data={userdata} style={{height:"370px",width:"100%"}} options={options} /> 
    </div>

  
  );
};

export default BarGraph;